(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('custom-update', {
                parent: 'update_management',
                url: '/custom-update',
                params: {
                    commands: null,
                    tag: '',
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null
                },
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.customUpdate.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/custom-update/custom-update.html',
                        controller: 'CustomUpdatesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customUpdate');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
